import React, { useRef } from "react";
import { Bar } from "@ant-design/charts";

const basic = {
	xField: "value",
	yField: "key",
	autoFit: true,
};

const slider = {
	start: 0.1,
	end: 0.7,
};

const normalLabel = {
	position: "middle",
	content: (item) => {
		if (item.value >= 0) return item?.value.toFixed(2) || item?.value;
		return 0;
	},
	style: {
		fill: "#ffffff",
	},
};

const rangeLabel = {
	position: "middle",
	content: (item) => {
		return item.value;
	},
	style: {
		fill: "#ffffff",
	},
};

const legend = {
	position: "top",
};
const seriesField = "type";
const isStack = true;
const isGroup = true;
const isPercent = true;
const isRange = true;

export default function BarChart(chartData = [], chartConfig = {}) {
	const label = chartConfig.isRange ? rangeLabel : normalLabel;
	const config = {
		data: chartData,
		...basic,
		isStack: chartConfig.isStack || chartConfig.isPercent ? isStack : false,
		isGroup: chartConfig.isGroup ? isGroup : false,
		isPercent: chartConfig.isPercent ? isPercent : false,
		isRange: chartConfig.isRange ? isRange : false,
		marginRatio: chartConfig.isGroup ? 0 : false,
		seriesField:
			chartConfig.isStack || chartConfig.isGroup || chartConfig.isPercent
				? seriesField
				: false,
		label: chartConfig.label ? label : false,
		slider: chartConfig.slider ? slider : false,
		legend: chartConfig.legend ? legend : false,
		barWidthRatio: chartConfig.isGroup ? 0.8 : 0.6,
	};

	let ref = useRef();

	return <Bar {...config} chartRef={ref} />;
}
